
export const DefaultFilterName = 'search';

export const HierarchyFilterDefaultName = 'hierarchyFilters';
